import { CLOSE_SNACKBAR, OPEN_SNACKBAR, SnackbarAction } from '../actions/snackbar.js'

const INITIAL_STATE = {
  snackbarOpened: false,
  level: '',
  message: '',
  action: {}
}

const snackbar = (state = INITIAL_STATE, action: SnackbarAction) => {
  switch (action.type) {
    case OPEN_SNACKBAR:
      return {
        ...state,
        snackbarOpened: true,
        level: action.level || 'info',
        message: action.message,
        action: {
          ...action.action
        }
      }
    case CLOSE_SNACKBAR:
      return {
        ...state,
        snackbarOpened: false
      }
    default:
      return state
  }
}

export default snackbar
